import { render } from "./SettingShift.vue?vue&type=template&id=0f179dcd&scoped=true"
import script from "./SettingShift.vue?vue&type=script&lang=js"
export * from "./SettingShift.vue?vue&type=script&lang=js"

import "./SettingShift.vue?vue&type=style&index=0&id=0f179dcd&scoped=true&lang=css"
import "./SettingShift.vue?vue&type=style&index=1&id=0f179dcd&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f179dcd"]])

export default __exports__